import { render, staticRenderFns } from "./ProductOptionSwatch.vue?vue&type=template&id=325cc0b5&scoped=true&"
import script from "./ProductOptionSwatch.vue?vue&type=script&lang=js&"
export * from "./ProductOptionSwatch.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionSwatch.vue?vue&type=style&index=0&id=325cc0b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325cc0b5",
  null
  
)

export default component.exports